import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import DossierDownloadDialog from "@/components/dialogs/DossierDownloadDialog.vue";
import NjButton from "@/components/vuetify-wrappers/NjButton.vue";
import { useSessionStore } from "@/pinia/session";
import { useFileDownloader } from "@/composition/useFileDownloader";
import {
  TypedURLSearchParams,
  UniversalSearchParams,
} from "@/types/api/SearchEndpointInputs";
import { ApiService, SnackbarService } from "@/services";
import { VignetteEndpoints } from "@/types";
import { useAppStore } from "@/pinia/app";


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkDossierDownloadButton',
  props: {
    searchParams: null,
    documentName: null
  },
  setup(__props: any) {

const props = __props as {
  searchParams: Partial<UniversalSearchParams> | TypedURLSearchParams;
  documentName: string;
};



const sessionStore = useSessionStore();
const useCustomLogo = ref(sessionStore.hasCustomLogo);

const appStore = useAppStore();
const urlOrigin = computed(() => appStore.baseUrlPath);

const formatSelection = ref("docx");
const orderSelection = ref("alphabetical");
watch([useCustomLogo, formatSelection, orderSelection], () => {
  calculateDownload();
});

const display = ref(false);
const downloadButtonText = computed(
  () => (isQuickDownload.value ? "Download" : "Email") + " Profile Book"
);
const profileCount = ref(0);

const {
  downloadFile,
  isDownloading,
  error: downloadErrorMessage,
} = useFileDownloader();

const checking = ref(false);
const isQuickDownload = ref(false);

const getAllParams = (): URLSearchParams => {
  let fileParams: URLSearchParams;
  if (props.searchParams instanceof TypedURLSearchParams) {
    fileParams = new URLSearchParams(props.searchParams.toString());
  } else {
    fileParams = new URLSearchParams();
    Object.entries(props.searchParams).forEach(([key, value]) => {
      if (typeof value === "string" && value.includes(",")) {
        value.split(",").forEach((v) => {
          fileParams.append(key, v);
        });
      } else {
        fileParams.append(key, value + "");
      }
    });
  }
  fileParams.append("datatype", formatSelection.value);
  fileParams.set("order", orderSelection.value);
  fileParams.append("doc_name", props.documentName);
  fileParams.append("use_custom_logo", useCustomLogo.value.toString());
  return fileParams;
};

const initiateDownload = async () => {
  const params = getAllParams();
  const currentDateInHumanReadableFormat = new Date()
    .toLocaleDateString("en-us", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    })
    .replace(/\//g, "-");
  const url =
    urlOrigin.value +
    VignetteEndpoints.API_BULK_DOSSIER_DOWNLOAD +
    "?" +
    params.toString();
  const fileType = formatSelection.value;
  const normalizedFileType =
    fileType === "zip_docx" ? "zip" : fileType === "zip_pdf" ? "zip" : fileType;
  await downloadFile(
    url,
    `${props.documentName} ${currentDateInHumanReadableFormat}.${normalizedFileType}`
  );
  if (downloadErrorMessage.value) {
    SnackbarService.displaySnackbar(downloadErrorMessage.value, "error");
  }
};

const user = sessionStore.user;
const isIpUser = computed(() => sessionStore.isIpUser);
const initiateEmail = async () => {
  const params = getAllParams() as TypedURLSearchParams;
  checking.value = true;
  const response = await ApiService.getBulkDossierEmail(params);
  if (response.ok) {
    const msg = `Your download is processing and will be emailed to ${user?.email} within the next few minutes.`;
    SnackbarService.displaySnackbar(msg, "primary");
  } else {
    SnackbarService.displaySnackbar(response.error?.message, "error");
  }
  checking.value = false;
};

const handleClick = async () => {
  if (isQuickDownload.value) {
    await initiateDownload();
  } else {
    await initiateEmail();
  }
};

const calculateDownload = async () => {
  checking.value = true;
  const response = await ApiService.getBulkDossierDownloadCheck(getAllParams());
  const { ok, data, error } = response;
  if (ok) {
    profileCount.value = data.num_profiles;
    isQuickDownload.value = data?.is_downloadable;
  } else {
    SnackbarService.displaySnackbar(error?.message, "error");
  }
  checking.value = false;
};

return { __sfc: true,props, sessionStore, useCustomLogo, appStore, urlOrigin, formatSelection, orderSelection, display, downloadButtonText, profileCount, downloadFile, isDownloading, downloadErrorMessage, checking, isQuickDownload, getAllParams, initiateDownload, user, isIpUser, initiateEmail, handleClick, calculateDownload, DossierDownloadDialog, NjButton }
}

})